// extracted by mini-css-extract-plugin
module.exports = {"name":"styles_name__F6Lvj","careers":"styles_careers__3Vcck","applicantType":"styles_applicantType__2eW8r"};